import React, { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';

export enum Colors {
  Blue = '#1e95f8',
  LightBlue = '#e8f4ff',
  White = '#fff',
}

interface SpinnerProps extends CircularProgressProps {
  background?: 'light' | 'dark';
}

const useStylesSpinner = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
    },
    top: {
      animationDuration: '3000ms',
      position: 'absolute',
      left: 0,
    },
    circle: {
      strokeLinecap: 'round',
    },
  }),
);

const Spinner: FC<SpinnerProps> = ({ background, ...props }) => {
  const classes = useStylesSpinner();

  const getSpinnerBackgroundColor = (): Colors | string => {
    if (background === 'light') {
      return Colors.LightBlue;
    }
    return Colors.White;
  };

  return (
    <div className={classes.root}>
      <CircularProgress
        variant="determinate"
        size={36}
        thickness={5}
        {...props}
        value={100}
        style={{ color: getSpinnerBackgroundColor() }}
      />
      <CircularProgress
        variant="indeterminate"
        className={classes.top}
        classes={{
          circle: classes.circle,
        }}
        size={36}
        thickness={5}
        style={{ color: Colors.Blue }}
        {...props}
      />
    </div>
  );
};

export default Spinner;
